<template>
    <Head>
        <title>Wakaf Pahang - Senarai kod bank</title>
        <link rel="shortcut apple-touch-icon icon" :href="img_favicon" type="image/png">
    </Head>
    <section ref="header" class="container-fluid py-3 position-fixed top-0 bg-wakaf-primary" style="z-index: 5">
        <div class="row">
            <h1 class="fs-3 text-center text-white" >Senarai kod bank</h1>
        </div>
    </section>
    <section ref="body" class="container-fluid">
        <div class="row">
            <div class="d-flex flex-column col-md-12">
                <span class="fs-4 fw-bold">Senarai kod bank mengikut bank</span>
                <span class="fs-6">Kemaskini kod bank mengikut bank</span>
            </div>
        </div>
        <div class="row mt-4">
            <div class="row justify-content-center">
                <div class="d-flex justify-content-between overflow-x-auto mb-3">
                    <!--<p>{{ $page.props.flash.message}}</p>-->
                    <div class="d-flex">
                    <Link replace class="btn btn-outline-primary" :href="uri_create">Tambah</Link>
                    </div>
                    <nav class="d-inline-block">
                        <ul class="pagination" style="margin: 0" v-if="codes.length > 0">
                            <li class="page-item disabled" v-if="paginator.current_page === 1">
                                <span class="page-link">...</span>
                            </li>
                            <li class="page-item" v-if="paginator.current_page !== 1">
                                <Link replace class="page-link" :href="uripagination(paginator.prev_page_url)">Sebelum</Link>
                            </li>
                            <template v-for="(page, index) in paginator.links">
                                <li class="page-item" v-if="page.url !== '' && !page.active && index !== 0 && index !== Object.keys(paginator.links).length-1">
                                    <Link replace class="page-link" :href="uripagination(page.url!) || ''">{{ page.label }}</Link>
                                </li>
                                <li class="page-item active" v-if="page.active">
                                    <Link replace class="page-link" :href="uripagination(page.url!)|| ''">{{ page.label }}</Link>
                                </li>
                            </template>
                            <li class="page-item" v-if="paginator.current_page !== paginator.last_page">
                                <Link replace class="page-link" :href="uripagination(paginator.next_page_url)">Seterusnya</Link>
                            </li>
                            <li class="page-item disabled" v-if="paginator.current_page === paginator.last_page">
                                <span class="page-link">...</span>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="d-inline-block mb-3">
                    <select class="form-select d-inline-block me-2" style="width: 250px;" v-model="selectedBank">
                        <option value="0">Semua bank</option>
                        <option v-for="bank in banks" :value="bank.ID">{{ bank.NamaBank }}</option>
                    </select>
                    <button class="btn btn-primary d-inline-block" @click="getDate()">Cari</button>
                </div>
                <div v-if="paginator.data.length>0" class="table-responsive">
                    <table class="table table-bordered table-striped" >
                        <thead class="table-dark">
                        <tr>
                            <th>No</th>
                            <th>Kod</th>
                            <th>Keterangan</th>
                            <th>Nama Bank</th>
                            <th>Tarikh Daftar</th>
                            <th>Tarikh Kemaskini</th>
                            <th>Tindakan</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(code, index) in codes">
                            <td>{{ ((paginator.current_page-1) * paginator.per_page)+index+1 }}</td>
                            <td>{{ code.kod }}</td>
                            <td>{{ code.keterangan }}</td>
                            <td>{{ code.bank }}</td>
                            <td>{{ (code.TarikhDaftar) }}</td>
                            <td>{{ (code.TarikhKemaskini) }}</td>
                            <td>
                                <Link replace class="btn btn-outline-wakaf-primary" :href="code.uri_edit"><font-awesome-icon :icon="faPenToSquare" /> Sunting</Link>
                                <button class="ms-2 btn btn-outline-danger" @click="deleteRow(code.kod, code.keterangan, code.uri_delete)"><font-awesome-icon :icon="faTrash" /> Buang</button>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="col-md-12">
                    <div class="alert alert-danger">
                        <p class="fs-5 text-center"><font-awesome-icon  :icon="faTriangleExclamation" /> Tiada rekod ditemui berdasarkan pilihan dibuat <font-awesome-icon  :icon="faFaceSadTear" /> </p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import {onMounted, Ref, ref} from "vue";
import {Head, Link, router, usePage} from "@inertiajs/vue3";
import {PageProps} from "@inertiajs/core";
import Swal from "sweetalert2";
import {faFaceSadTear, faPenToSquare, faPlus, faTrash, faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {library} from "@fortawesome/fontawesome-svg-core";
library.add(faPenToSquare, faPlus, faTrash,faTriangleExclamation, faFaceSadTear);

interface Data{
    id: number,
    kod: string,
    keterangan: string,
    TarikhDaftar: string,
    TarikhKemaskini: string,
    bank: string,
    uri_edit: string,
    uri_delete: string,
}

const data = defineProps<{
    csrf: string,
    img_favicon: string,
    codes: Data[],
    banks: {
        ID: number,
        NamaBank: string
    }[],
    uri_create: string,
    uri_main: string,
    selectedkodbank?: number | undefined,
    paginator:  {
        current_page: number,
        data: Data[],
        first_page_url: string,
        from: number,
        last_page: number,
        last_page_url: string,
        links:{
            active: boolean,
            label: string,
            url?: string,
        }[],
        next_page_url: string,
        path: string,
        per_page: number,
        prev_page_url: string,
        to: number,
        total: number
    },
}>();

const header: Ref = ref<HTMLDivElement>();
const body: Ref = ref<HTMLDivElement>();
const selectedBank = ref<number>(0);
//const bodys = $page.props;


interface ServerInfo extends PageProps {
    flash:{
        message: string | null
    } | null
}
onMounted(() => {
    body.value.style.marginTop = header.value.clientHeight+10 +"px";
    window.addEventListener("resize", ()=>{
        body.value.style.marginTop = header.value.clientHeight+10 +"px";
    });
    if(data.selectedkodbank !== undefined){
        selectedBank.value = data.selectedkodbank!;
    }
    const message = (usePage().props as unknown) as ServerInfo;
    if (message.flash?.message !== null){
        Swal.fire({
            position: "top-right",
            icon: "success",
            title: message.flash?.message,
            timer: 3500
        });
    }
});

const getDate = (): void => {
    router.get(data.uri_main,{
        id: selectedBank.value
    })
}

const deleteRow = (kod: string, keterangan: string, uri_delete: string): void =>{
    Swal.fire({
        title: `Anda pasti untuk padam ${kod} - ${keterangan}?`,
        showConfirmButton: true,
        confirmButtonText: "Ok",
        showCancelButton: true,
        cancelButtonText: "Kembali",
        cancelButtonColor: "#0d6efd",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        backdrop: true,
        reverseButtons: true,
        preConfirm: async() => {
            router.delete(uri_delete,{
                onError: () => {
                    Swal.fire({
                        icon: "error",
                        title: "Ralat berlaku",
                        text: "Sila cuba semula untuk hantar",
                        timer: 5000,
                        timerProgressBar: true,
                        confirmButtonColor: "#0d6efd",
                        confirmButtonText: "Ok",
                    })
                },
                onSuccess:() =>{
                    const message = (usePage().props as unknown) as ServerInfo
                    if (message.flash?.message !== null){
                        Swal.fire({
                            position: "top-right",
                            icon: "success",
                            title: message.flash?.message,
                            timer: 3500
                        });
                    }
                }
            });
        },
    })
}

const uripagination = (uri: string| null): string => {
    if (selectedBank.value === 0){
        console.log(selectedBank.value)
        return uri!;
    }
    if(uri?.indexOf("?") === -1){
       return uri?.concat("?id="+selectedBank.value)!
    }else{
       return uri?.concat("&id="+selectedBank.value)!
    }
}
</script>

<style scoped>

</style>
